const securityData = {
  id: "security",
  name: "Security",
  resolved: "3",
  outstanding: "4",
  today: "2",
  values: [
    {
      iconsInfo: [
        {
          type: "vip",
          total: "56",
          available: "174",
          icon: "",
        },
        {
          type: "",
          total: "26",
          available: "174",
          icon: "",
        },
        {
          type: "",
          total: "05",
          available: "174",
          icon: "",
        },
        {
          type: "",
          total: "25",
          available: "174",
          icon: "",
        },
      ],
      analytics: {
        day: {
          analyticsData: [
            {
              metricName: "tailgating",
              analytics: [
                {
                  node: "2022-10-11T11:00:00",
                  count: 66,
                },
                {
                  node: "2022-10-11T13:00:00",
                  count: 147.0,
                },
                {
                  node: "2022-10-11T15:00:00",
                  count: 70.0,
                },
                {
                  node: "2022-10-11T17:00:00",
                  count: 127.0,
                },
                {
                  node: "2022-10-11T19:00:00",
                  count: 57.0,
                },
                {
                  node: "2022-10-11T21:00:00",
                  count: 127.0,
                },
                {
                  node: "2022-10-11T11:00:00",
                  count: 66,
                },
                {
                  node: "2022-10-11T13:00:00",
                  count: 147.0,
                },
                {
                  node: "2022-10-11T15:00:00",
                  count: 70.0,
                },
                {
                  node: "2022-10-11T17:00:00",
                  count: 127.0,
                },
                {
                  node: "2022-10-11T19:00:00",
                  count: 57.0,
                },
                {
                  node: "2022-10-11T21:00:00",
                  count: 127.0,
                },
                {
                  node: "2022-10-11T11:00:00",
                  count: 66,
                },
                {
                  node: "2022-10-11T13:00:00",
                  count: 147.0,
                },
                {
                  node: "2022-10-11T15:00:00",
                  count: 70.0,
                },
                {
                  node: "2022-10-11T17:00:00",
                  count: 127.0,
                },
                {
                  node: "2022-10-11T19:00:00",
                  count: 57.0,
                },
                {
                  node: "2022-10-11T21:00:00",
                  count: 127.0,
                },
                {
                  node: "2022-10-11T11:00:00",
                  count: 66,
                },
                {
                  node: "2022-10-11T13:00:00",
                  count: 147.0,
                },
                {
                  node: "2022-10-11T15:00:00",
                  count: 70.0,
                },
                {
                  node: "2022-10-11T17:00:00",
                  count: 127.0,
                },
                {
                  node: "2022-10-11T19:00:00",
                  count: 57.0,
                },
                {
                  node: "2022-10-11T21:00:00",
                  count: 127.0,
                },
              ],
            },
            {
              metricName: "crowdforming",
              analytics: [
                {
                  node: "2022-10-11T11:00:00",
                  count: 60,
                },
                {
                  node: "2022-10-11T13:00:00",
                  count: 167.0,
                },
                {
                  node: "2022-10-11T15:00:00",
                  count: 90.0,
                },
                {
                  node: "2022-10-11T17:00:00",
                  count: 157.0,
                },
                {
                  node: "2022-10-11T19:00:00",
                  count: 77.0,
                },
                {
                  node: "2022-10-11T21:00:00",
                  count: 147.0,
                },
                {
                  node: "2022-10-11T11:00:00",
                  count: 60,
                },
                {
                  node: "2022-10-11T13:00:00",
                  count: 167.0,
                },
                {
                  node: "2022-10-11T15:00:00",
                  count: 90.0,
                },
                {
                  node: "2022-10-11T17:00:00",
                  count: 157.0,
                },
                {
                  node: "2022-10-11T19:00:00",
                  count: 77.0,
                },
                {
                  node: "2022-10-11T21:00:00",
                  count: 147.0,
                },
                {
                  node: "2022-10-11T11:00:00",
                  count: 60,
                },
                {
                  node: "2022-10-11T13:00:00",
                  count: 167.0,
                },
                {
                  node: "2022-10-11T15:00:00",
                  count: 90.0,
                },
                {
                  node: "2022-10-11T17:00:00",
                  count: 157.0,
                },
                {
                  node: "2022-10-11T19:00:00",
                  count: 77.0,
                },
                {
                  node: "2022-10-11T21:00:00",
                  count: 147.0,
                },
                {
                  node: "2022-10-11T11:00:00",
                  count: 60,
                },
                {
                  node: "2022-10-11T13:00:00",
                  count: 167.0,
                },
                {
                  node: "2022-10-11T15:00:00",
                  count: 90.0,
                },
                {
                  node: "2022-10-11T17:00:00",
                  count: 157.0,
                },
                {
                  node: "2022-10-11T19:00:00",
                  count: 77.0,
                },
                {
                  node: "2022-10-11T21:00:00",
                  count: 147.0,
                },
              ],
            },
            {
              metricName: "unauthorizedaccess",
              analytics: [
                {
                  node: "2022-10-11T11:00:00",
                  count: 65,
                },
                {
                  node: "2022-10-11T13:00:00",
                  count: 187.0,
                },
                {
                  node: "2022-10-11T15:00:00",
                  count: 55.0,
                },
                {
                  node: "2022-10-11T17:00:00",
                  count: 187.0,
                },
                {
                  node: "2022-10-11T19:00:00",
                  count: 57.0,
                },
                {
                  node: "2022-10-11T21:00:00",
                  count: 167.0,
                },
                {
                  node: "2022-10-11T11:00:00",
                  count: 65,
                },
                {
                  node: "2022-10-11T13:00:00",
                  count: 187.0,
                },
                {
                  node: "2022-10-11T15:00:00",
                  count: 55.0,
                },
                {
                  node: "2022-10-11T17:00:00",
                  count: 187.0,
                },
                {
                  node: "2022-10-11T19:00:00",
                  count: 57.0,
                },
                {
                  node: "2022-10-11T21:00:00",
                  count: 167.0,
                },
                {
                  node: "2022-10-11T11:00:00",
                  count: 65,
                },
                {
                  node: "2022-10-11T13:00:00",
                  count: 187.0,
                },
                {
                  node: "2022-10-11T15:00:00",
                  count: 55.0,
                },
                {
                  node: "2022-10-11T17:00:00",
                  count: 187.0,
                },
                {
                  node: "2022-10-11T19:00:00",
                  count: 57.0,
                },
                {
                  node: "2022-10-11T21:00:00",
                  count: 167.0,
                },
                {
                  node: "2022-10-11T11:00:00",
                  count: 65,
                },
                {
                  node: "2022-10-11T13:00:00",
                  count: 187.0,
                },
                {
                  node: "2022-10-11T15:00:00",
                  count: 55.0,
                },
                {
                  node: "2022-10-11T17:00:00",
                  count: 187.0,
                },
                {
                  node: "2022-10-11T19:00:00",
                  count: 57.0,
                },
                {
                  node: "2022-10-11T21:00:00",
                  count: 167.0,
                },
              ],
            },
          ],
        },
        weekly: {
          analyticsData: [
            {
              metricName: "tailgating",
              analytics: [
                {
                  node: "2022-06-11T11:00:00",
                  count: 166,
                },
                {
                  node: "2022-07-11T12:00:00",
                  count: 47.0,
                },
                {
                  node: "2022-08-11T13:00:00",
                  count: 170.0,
                },
                {
                  node: "2022-09-11T14:00:00",
                  count: 27.0,
                },
                {
                  node: "2022-10-11T15:00:00",
                  count: 157.0,
                },
                {
                  node: "2022-11-11T16:00:00",
                  count: 27.0,
                },
                {
                  node: "2022-12-11T11:00:00",
                  count: 166,
                },
              ],
            },
            {
              metricName: "crowdforming",
              analytics: [
                {
                  node: "2022-06-11T11:00:00",
                  count: 160,
                },
                {
                  node: "2022-07-11T12:00:00",
                  count: 67.0,
                },
                {
                  node: "2022-08-11T13:00:00",
                  count: 190.0,
                },
                {
                  node: "2022-09-11T14:00:00",
                  count: 57.0,
                },
                {
                  node: "2022-10-11T15:00:00",
                  count: 177.0,
                },
                {
                  node: "2022-11-11T16:00:00",
                  count: 47.0,
                },
                {
                  node: "2022-12-11T11:00:00",
                  count: 160,
                },
              ],
            },
            {
              metricName: "unauthorizedaccess",
              analytics: [
                {
                  node: "2022-06-11T11:00:00",
                  count: 165,
                },
                {
                  node: "2022-07-11T12:00:00",
                  count: 87.0,
                },
                {
                  node: "2022-08-11T13:00:00",
                  count: 155.0,
                },
                {
                  node: "2022-09-11T14:00:00",
                  count: 87.0,
                },
                {
                  node: "2022-10-11T15:00:00",
                  count: 157.0,
                },
                {
                  node: "2022-11-11T16:00:00",
                  count: 67.0,
                },
                {
                  node: "2022-12-11T11:00:00",
                  count: 165,
                },
              ],
            },
          ],
        },
        monthly: {
          analyticsData: [
            {
              metricName: "tailgating",
              analytics: [
                {
                  node: "2022-06-11T11:00:00",
                  count: 66,
                },
                {
                  node: "2022-07-11T12:00:00",
                  count: 147.0,
                },
                {
                  node: "2022-08-11T13:00:00",
                  count: 70.0,
                },
                {
                  node: "2022-09-11T14:00:00",
                  count: 127.0,
                },
                {
                  node: "2022-10-11T15:00:00",
                  count: 57.0,
                },
                {
                  node: "2022-11-11T16:00:00",
                  count: 127.0,
                },
                {
                  node: "2022-08-11T13:00:00",
                  count: 70.0,
                },
                {
                  node: "2022-09-11T14:00:00",
                  count: 127.0,
                },
                {
                  node: "2022-10-11T15:00:00",
                  count: 57.0,
                },
                {
                  node: "2022-11-11T16:00:00",
                  count: 127.0,
                },
                {
                  node: "2022-06-11T11:00:00",
                  count: 66,
                },
                {
                  node: "2022-07-11T12:00:00",
                  count: 147.0,
                },
                {
                  node: "2022-08-11T13:00:00",
                  count: 70.0,
                },
                {
                  node: "2022-09-11T14:00:00",
                  count: 127.0,
                },
                {
                  node: "2022-10-11T15:00:00",
                  count: 57.0,
                },
                {
                  node: "2022-11-11T16:00:00",
                  count: 127.0,
                },
                {
                  node: "2022-08-11T13:00:00",
                  count: 70.0,
                },
                {
                  node: "2022-09-11T14:00:00",
                  count: 127.0,
                },
                {
                  node: "2022-10-11T15:00:00",
                  count: 57.0,
                },
                {
                  node: "2022-11-11T16:00:00",
                  count: 127.0,
                },
                {
                  node: "2022-06-11T11:00:00",
                  count: 66,
                },
                {
                  node: "2022-07-11T12:00:00",
                  count: 147.0,
                },
                {
                  node: "2022-08-11T13:00:00",
                  count: 70.0,
                },
                {
                  node: "2022-09-11T14:00:00",
                  count: 127.0,
                },
                {
                  node: "2022-10-11T15:00:00",
                  count: 57.0,
                },
                {
                  node: "2022-11-11T16:00:00",
                  count: 127.0,
                },
                {
                  node: "2022-08-11T13:00:00",
                  count: 70.0,
                },
                {
                  node: "2022-09-11T14:00:00",
                  count: 127.0,
                },
                {
                  node: "2022-10-11T15:00:00",
                  count: 57.0,
                },
                {
                  node: "2022-11-11T16:00:00",
                  count: 127.0,
                },
              ],
            },
            {
              metricName: "crowdforming",
              analytics: [
                {
                  node: "2022-06-11T11:00:00",
                  count: 60,
                },
                {
                  node: "2022-07-11T12:00:00",
                  count: 167.0,
                },
                {
                  node: "2022-08-11T13:00:00",
                  count: 90.0,
                },
                {
                  node: "2022-09-11T14:00:00",
                  count: 157.0,
                },
                {
                  node: "2022-10-11T15:00:00",
                  count: 77.0,
                },
                {
                  node: "2022-11-11T16:00:00",
                  count: 147.0,
                },
                {
                  node: "2022-09-11T14:00:00",
                  count: 157.0,
                },
                {
                  node: "2022-10-11T15:00:00",
                  count: 77.0,
                },
                {
                  node: "2022-11-11T16:00:00",
                  count: 147.0,
                },
                {
                  node: "2022-06-11T11:00:00",
                  count: 60,
                },
                {
                  node: "2022-07-11T12:00:00",
                  count: 167.0,
                },
                {
                  node: "2022-08-11T13:00:00",
                  count: 90.0,
                },
                {
                  node: "2022-09-11T14:00:00",
                  count: 157.0,
                },
                {
                  node: "2022-10-11T15:00:00",
                  count: 77.0,
                },
                {
                  node: "2022-11-11T16:00:00",
                  count: 147.0,
                },
                {
                  node: "2022-09-11T14:00:00",
                  count: 157.0,
                },
                {
                  node: "2022-10-11T15:00:00",
                  count: 77.0,
                },
                {
                  node: "2022-11-11T16:00:00",
                  count: 147.0,
                },
                {
                  node: "2022-06-11T11:00:00",
                  count: 60,
                },
                {
                  node: "2022-07-11T12:00:00",
                  count: 167.0,
                },
                {
                  node: "2022-08-11T13:00:00",
                  count: 90.0,
                },
                {
                  node: "2022-09-11T14:00:00",
                  count: 157.0,
                },
                {
                  node: "2022-10-11T15:00:00",
                  count: 77.0,
                },
                {
                  node: "2022-11-11T16:00:00",
                  count: 147.0,
                },
                {
                  node: "2022-09-11T14:00:00",
                  count: 157.0,
                },
                {
                  node: "2022-10-11T15:00:00",
                  count: 77.0,
                },
                {
                  node: "2022-11-11T16:00:00",
                  count: 147.0,
                },
              ],
            },
            {
              metricName: "unauthorizedaccess",
              analytics: [
                {
                  node: "2022-06-11T11:00:00",
                  count: 65,
                },
                {
                  node: "2022-07-11T12:00:00",
                  count: 187.0,
                },
                {
                  node: "2022-08-11T13:00:00",
                  count: 55.0,
                },
                {
                  node: "2022-09-11T14:00:00",
                  count: 187.0,
                },
                {
                  node: "2022-10-11T15:00:00",
                  count: 57.0,
                },
                {
                  node: "2022-11-11T16:00:00",
                  count: 167.0,
                },
                {
                  node: "2022-08-11T13:00:00",
                  count: 55.0,
                },
                {
                  node: "2022-09-11T14:00:00",
                  count: 187.0,
                },
                {
                  node: "2022-10-11T15:00:00",
                  count: 57.0,
                },
                {
                  node: "2022-11-11T16:00:00",
                  count: 167.0,
                },
                {
                  node: "2022-06-11T11:00:00",
                  count: 65,
                },
                {
                  node: "2022-07-11T12:00:00",
                  count: 187.0,
                },
                {
                  node: "2022-08-11T13:00:00",
                  count: 55.0,
                },
                {
                  node: "2022-09-11T14:00:00",
                  count: 187.0,
                },
                {
                  node: "2022-10-11T15:00:00",
                  count: 57.0,
                },
                {
                  node: "2022-11-11T16:00:00",
                  count: 167.0,
                },
                {
                  node: "2022-08-11T13:00:00",
                  count: 55.0,
                },
                {
                  node: "2022-09-11T14:00:00",
                  count: 187.0,
                },
                {
                  node: "2022-10-11T15:00:00",
                  count: 57.0,
                },
                {
                  node: "2022-11-11T16:00:00",
                  count: 167.0,
                },
                {
                  node: "2022-06-11T11:00:00",
                  count: 65,
                },
                {
                  node: "2022-07-11T12:00:00",
                  count: 187.0,
                },
                {
                  node: "2022-08-11T13:00:00",
                  count: 55.0,
                },
                {
                  node: "2022-09-11T14:00:00",
                  count: 187.0,
                },
                {
                  node: "2022-10-11T15:00:00",
                  count: 57.0,
                },
                {
                  node: "2022-11-11T16:00:00",
                  count: 167.0,
                },
                {
                  node: "2022-08-11T13:00:00",
                  count: 55.0,
                },
                {
                  node: "2022-09-11T14:00:00",
                  count: 187.0,
                },
                {
                  node: "2022-10-11T15:00:00",
                  count: 57.0,
                },
                {
                  node: "2022-11-11T16:00:00",
                  count: 167.0,
                },
              ],
            },
          ],
        },
        yearly: {
          analyticsData: [
            {
              metricName: "tailgating",
              analytics: [
                {
                  node: "2022-06-11T11:00:00",
                  count: 166,
                },
                {
                  node: "2022-07-11T12:00:00",
                  count: 47.0,
                },
                {
                  node: "2022-08-11T13:00:00",
                  count: 170.0,
                },
                {
                  node: "2022-09-11T14:00:00",
                  count: 27.0,
                },
                {
                  node: "2022-10-11T15:00:00",
                  count: 157.0,
                },
                {
                  node: "2022-11-11T16:00:00",
                  count: 27.0,
                },
                {
                  node: "2022-06-11T11:00:00",
                  count: 166,
                },
                {
                  node: "2022-07-11T12:00:00",
                  count: 47.0,
                },
                {
                  node: "2022-08-11T13:00:00",
                  count: 170.0,
                },
                {
                  node: "2022-09-11T14:00:00",
                  count: 27.0,
                },
                {
                  node: "2022-10-11T15:00:00",
                  count: 157.0,
                },
                {
                  node: "2022-11-11T16:00:00",
                  count: 27.0,
                },
              ],
            },
            {
              metricName: "crowdforming",
              analytics: [
                {
                  node: "2022-06-11T11:00:00",
                  count: 160,
                },
                {
                  node: "2022-07-11T12:00:00",
                  count: 67.0,
                },
                {
                  node: "2022-08-11T13:00:00",
                  count: 190.0,
                },
                {
                  node: "2022-09-11T14:00:00",
                  count: 57.0,
                },
                {
                  node: "2022-10-11T15:00:00",
                  count: 177.0,
                },
                {
                  node: "2022-11-11T16:00:00",
                  count: 47.0,
                },
                {
                  node: "2022-06-11T11:00:00",
                  count: 160,
                },
                {
                  node: "2022-07-11T12:00:00",
                  count: 67.0,
                },
                {
                  node: "2022-08-11T13:00:00",
                  count: 190.0,
                },
                {
                  node: "2022-09-11T14:00:00",
                  count: 57.0,
                },
                {
                  node: "2022-10-11T15:00:00",
                  count: 177.0,
                },
                {
                  node: "2022-11-11T16:00:00",
                  count: 47.0,
                },
              ],
            },
            {
              metricName: "unauthorizedaccess",
              analytics: [
                {
                  node: "2022-06-11T11:00:00",
                  count: 165,
                },
                {
                  node: "2022-07-11T12:00:00",
                  count: 87.0,
                },
                {
                  node: "2022-08-11T13:00:00",
                  count: 155.0,
                },
                {
                  node: "2022-09-11T14:00:00",
                  count: 87.0,
                },
                {
                  node: "2022-10-11T15:00:00",
                  count: 157.0,
                },
                {
                  node: "2022-11-11T16:00:00",
                  count: 67.0,
                },
                {
                  node: "2022-06-11T11:00:00",
                  count: 165,
                },
                {
                  node: "2022-07-11T12:00:00",
                  count: 87.0,
                },
                {
                  node: "2022-08-11T13:00:00",
                  count: 155.0,
                },
                {
                  node: "2022-09-11T14:00:00",
                  count: 87.0,
                },
                {
                  node: "2022-10-11T15:00:00",
                  count: 157.0,
                },
                {
                  node: "2022-11-11T16:00:00",
                  count: 67.0,
                },
              ],
            },
          ],
        },
      },
      notifications: {
        events: {
          totalCount: "5",

          list: [
            {
              category: "security",

              id: "security-01",

              title: "Access Denied",

              timeStamp: "12-15-2022 | 09:00 AM",

              // vehicleId: "#34567C15A",

              spot: "A1",

              parkingLot: "Parking Lot - A1",

              img: "",

              video: "",

              location: {
                lat: 40.75823545824867,

                lng: -73.84795241810363,
              },
            },

            {
              category: "security",

              id: "security-02",

              title: "License Plate Number Not Found",

              timeStamp: "12-15-2022 | 09:00 AM",

              // vehicleId: "#34567C15A",

              spot: "A1",

              parkingLot: "Parking Lot - A1",

              img: "",

              video: "",

              location: {
                lat: 40.75857627161138,

                lng: -73.84610103835523,
              },
            },

            {
              category: "security",

              id: "security-03",

              title: "Maintenance Completed",

              timeStamp: "12-15-2022 | 09:00 AM",

              // vehicleId: "#34567C15A",

              spot: "D",

              parkingLot: "Parking Lot - D",

              img: "",

              video: "",

              location: {
                lat: 40.755765905921905,

                lng: -73.84814050655918,
              },
            },

            {
              category: "security",

              id: "security-04",

              title: "Maintenance Inprogress",

              timeStamp: "12-15-2022 | 09:00 AM",

              spot: "E1",

              parkingLot: "Parking Lot - E1",

              img: "",

              video: "",

              location: {
                lat: 40.75486354659446,

                lng: -73.84978904593407,
              },
            },

            {
              category: "security",

              id: "security-05",

              title: "License Plate Number Not Found",

              timeStamp: "12-15-2022 | 09:00 AM",

              spot: "F",

              parkingLot: "Parking Lot - F",

              img: "",

              video: "",

              location: {
                lat: 40.75472106769027,

                lng: -73.84751354532696,
              },
            },
          ],
        },

        incidents: {
          totalCount: "6",

          list: [
            {
              category: "security",

              id: "ict-01",

              title: "Unauthorized Access",

              timeStamp: "12-15-2022 | 09:00 AM",

              // vehicleId: "#34567C15A",

              spot: "B1",

              parkingLot: "Main entrance door",

              img: "",

              video: "",

              location: {
                lat: 40.75675206167507,

                lng: -73.84716318457585,
              },
            },

            {
              category: "security",

              id: "ict-02",

              title: "Tailgating",

              timeStamp: "12-15-2022 | 09:00 AM",

              // vehicleId: "#34567C15A",

              spot: "B1",

              parkingLot: "Parking Lot - B1",

              img: "",

              video: "",

              location: {
                lat: 40.756520190673626,

                lng: -73.84780858588256,
              },
            },

            {
              category: "security",

              id: "ict-03",

              title: "Tailgating",

              timeStamp: "12-15-2022 | 09:00 AM",

              // vehicleId: "#34567C15A",

              spot: "D1",

              parkingLot: "Parking Lot - D1",

              img: "",

              video: "",

              location: {
                lat: 40.75572958828776,

                lng: -73.84779752186017,
              },
            },

            {
              category: "security",

              id: "ict-04",

              title: "Crowd Forming",

              timeStamp: "12-15-2022 | 09:00 AM",

              // vehicleId: "#34567C15A",

              spot: "B1",

              parkingLot: "Parking Lot - B1",

              img: "",

              video: "",

              location: {
                lat: 40.75671295096044,

                lng: -73.8479376661439,
              },
            },

            {
              category: "security",

              id: "ict-05",

              title: "Accident Detected",

              timeStamp: "12-15-2022 | 09:00 AM",

              vehicleId: "#34567C15A",

              spot: "A1",

              parkingLot: "Parking Lot - A",

              img: "",

              video: "",

              location: {
                lat: 40.75797565672968,

                lng: -73.84800773823898,
              },
            },

            {
              category: "security",

              id: "ict-06",

              title: "Crowd Forming",

              timeStamp: "12-15-2022 | 09:00 AM",

              // vehicleId: "#34567C15A",

              spot: "B1",

              parkingLot: "Parking Lot - B2",

              img: "",

              video: "",

              location: {
                lat: 40.756707363728836,

                lng: -73.84806674636111,
              },
            },
          ],
        },

        operationalAlerts: {
          totalCount: "5",

          list: [
            {
              category: "security",

              id: "opr-01",

              title: "Fire Alert",

              timeStamp: "12-15-2022 | 09:00 AM",

              //vehicleId: "#54567C15A",

              spot: "F",

              parkingLot: "Parking Lot - F",

              img: "",

              video: "",

              location: {
                lat: 40.75518482143883,

                lng: -73.8475725533632,
              },
            },

            // {
            //   category: "security",

            //   id: "opr-02",

            //   title: "Parking Slot Under Maintenance ",

            //   timeStamp: "12-15-2022 | 09:00 AM",

            //   //vehicleId: "#54567C15A",

            //   spot: "E1",

            //   parkingLot: "Parking Lot - E",

            //   img: "",

            //   video: "",

            //   location: {
            //     lat: 40.7541399740813,

            //     lng: -73.84903300439449,
            //   },
            // },

            {
              category: "security",

              id: "opr-03",

              title: "Camera Not Functional",

              timeStamp: "12-15-2022 | 09:00 AM",

              //vehicleId: "#54567C15A",

              spot: "C1",

              parkingLot: "Parking Lot - C1",

              img: "",

              video: "",

              location: {
                lat: 40.75629669977691,

                lng: -73.84832859495937,
              },
            },

            {
              category: "security",

              id: "opr-04",

              title: "Elevators Not Functional",

              timeStamp: "12-15-2022 | 09:00 AM",

              //vehicleId: "#54567C15A",

              spot: "Lobby",

              parkingLot: "2nd Floor",

              img: "",

              video: "",

              location: {
                lat: 40.75684983836016,

                lng: -73.84677594373161,
              },
            },

            {
              category: "security",

              id: "opr-05",

              title: "Re-entry Gate Closed",

              timeStamp: "12-15-2022 | 09:00 AM",

              // vehicleId: "#54567C15A",

              spot: "C1",

              parkingLot: "Parking Lot - C1",

              img: "",

              video: "",

              location: {
                lat: 40.75799800528403,

                lng: -73.84592401398045,
              },
            },
          ],
        },
      },
    },
  ],
};
export default securityData;
